module.exports = __webpack_public_path__ + "img/kajak1.620b2a50.jpg";